<template>
    <div>
            <div class="text-center mb-20 glot-text-color-EB">
                  <span class="" v-html="$t('WelcomeBack')"></span><br/>
                 <div class="" v-html="$t('LoginTitle')"></div>
                  <b v-for="(name, index) in nameDomain" :key="name">
                    {{name}}
                    <b v-if="index < nameDomain.length - 1">&</b>
                  </b>
            </div>
        <div>
        
          <div class="flex items-center glot-background-color-26 rounded-lg mb-2 p-4">
            <vs-avatar v-src="lastUser.photo" class="flex-shrink-0 mr-2" size="48px" />
            <span class="glot-text-color-C2 glot-text-font-size-16 ml-2 flex-grow">{{hiddenEmail}}</span>
            <a class="flex justify-center items-center"  @keyup.enter.prevent="loginAnotherAcc" tabindex="0"><feather-icon @click="loginAnotherAcc" icon="XCircleIcon" class="w-4 h-4 cursor-pointer" /></a>
          </div >

          <form v-if="lastUser.type==='local'"
            @submit.prevent="validForm('loginAgainForm')"
            data-vv-scope="loginAgainForm"
          >
          <div class="relative">
          <vs-input
                    data-vv-validate-on="blur"
                    v-validate="'required|min:6'"
                    :type="passwordType"
                    name="password"
                    icon-no-border
                    :placeholder="$t('YourPassWord')"
                    v-model="password"
                    class="w-full" />
          <span class="absolute m-auto top-0 bottom-0 right-0 mr-1 flex items-center cursor-pointer" >
          <feather-icon :icon="[passwordIcon]" @click="hidePassword = !hidePassword" svgClasses="h-4 w-4 stroke-current text-grey absolute m-auto top-0 bottom-0 right-0 mr-1" class="block" />
          </span>
          </div>
          <div class="text-danger text-sm">{{ errors.first('loginAgainForm.password') }}</div>
          <input class="opacity-0 absolute" type="submit"/>
          </form>

          <div class="text-danger text-sm">{{ errMessage }}</div>

          <div class="mt-10">
             <div @click="clickLoginOther('Google')" v-if="lastUser.type==='google'" class="flex rounded-lg glot-background-color-F8 py-3 flex-1 text-center justify-center items-end cursor-pointer">
                   <img src="@/assets/images/svg/icons/googleIcon.svg" class="mr-2"/>
                   <a @keyup.enter.prevent="clickLoginOther('Google')" tabindex="0" class="glot-text-color-51 glot-text-font-size-16 font-bold" style="line-height: unset">{{$t('GoogleSignIn')}}</a>
             </div>

            <div @click="clickLoginOther('Facebook')" v-if="lastUser.type==='facebook'" class="flex rounded-lg glot-background-color-F8 py-3 flex-1 text-center justify-center items-end cursor-pointer">
                <img class="inline-block mr-2" src="@/assets/images/icons/facebookIcon.png" />
                <a @keyup.enter.prevent="clickLoginOther('Facebook')" style="line-height: unset" tabindex="0" class="glot-text-color-3B glot-text-font-size-16 font-bold">{{$t('FacebookSignIn')}}</a>
            </div>

            <div @click="clickLoginOther('Apple')" v-if="lastUser.type==='apple'" class="flex rounded-lg glot-background-color-F8 py-3 flex-1 text-center justify-center items-end cursor-pointer">
                <img src="@/assets/images/icons/appleIcon.png" class="mr-2"/>
                <a @keyup.enter.prevent="clickLoginOther('Apple')" tabindex="0" class="glot-text-color-2C glot-text-font-size-16 font-bold" style="line-height: unset">{{$t('AppleSignIn')}}</a>
             </div>

            <vs-button tabindex="0" v-if="lastUser.type==='local'" :disabled="!validateForm" @click="validForm('loginAgainForm')" class="w-full glot-background-color-1D">{{$t('Login').toUpperCase()}}</vs-button>

             <div class="mt-2 text-center"> 
               <span class="glot-text-color-EB glot-text-font-size-16 glot-text-line-height-20">{{$t('NotYou')}}</span>
               <a tabindex="0" @keyup.enter.prevent="loginAnotherAcc" @click.prevent="loginAnotherAcc" class="glot-text-color-1D glot-text-font-size-16 glot-text-line-height-20 ml-1 cursor-pointer">{{$t('SignInDiffAcc')}}</a>
               </div>
          </div>
        </div>
    </div>
</template>

<script>

import {getErrorMessage} from '@/i18n/util'
import {getMainDomain} from '@/utils/getMainDomain'
import _throttle from 'lodash/throttle'
import {CONNECT_FACEBOOK, CONNECT_GOOGLE, GLOT_SECRET_COOKIE} from '@/config/commonConfig'

export default {
  props:{
    nameDomain: String
  },
  components: {
  },
  data () {
    return {
      password: '',
      hidePassword: true,
      errMessage: '',
      clientId: process.env.VUE_APP_CLIENT_ID,
      scope: process.env.VUE_APP_SCOPE,
      redirectURI: getMainDomain(process.env.VUE_APP_REDIRECT_URL),
      state: process.env.VUE_APP_STATE,
      usePopup: process.env.VUE_APP_USE_POPUP,
      nonce: process.env.VUE_APP_NONE
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any() && this.lastUser.name !== '' && this.password !== ''
    },
    hiddenEmail () {
      const email = this.lastUser.name || ''
      // return email

      return email.replace(/(.{2})(.*)(?=@)/,
        function (gp1, gp2, gp3) { 
          for (let i = 0; i < gp3.length; i++) { 
            gp2 += '*' 
          } return gp2 
        })
    },
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    },
    passwordType () {
      return this.hidePassword ? 'password' : 'text'
    },
    passwordIcon () {
      return this.hidePassword ? 'EyeIcon' : 'EyeOffIcon'
    },
    lastUser () {
      return this.$store.state.LastUser
    }
  },
  methods:{
    checkLogin () {
      // If user is already logged in notify
      if (this.$store.state.auth.isUserAlreadyLoggedIn()) {
        // Close animation if passed as payload
        // this.$vs.loading.close()


        return false
      }
      return true
    },
    clickLoginOther (type) {
      if (type === 'Facebook') {
        window.location.href = CONNECT_FACEBOOK
      }
      if (type === 'Google') {
        window.location.href = CONNECT_GOOGLE
      }
      if (type === 'Apple') {
        this.$vs.loading({
          background: 'rgba(0, 0, 0, 0.6)'
        })
        window.AppleID.auth.signIn().then((response) => {
          this.$vs.loading.close()
          const {authorization: {id_token}} = response
          this.$router.push(`/auth/apple/callback?access_token=${id_token}`)
        }).catch((err) => {
          this.$vs.loading.close()
          const { message } = err
          if (message) {
            this.$vs.notify({
              title: 'Error',
              text:  message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger',
              fixed: true
            })
          }
        })
      }
    },
    loginAnotherAcc () {
      this.$cookies.remove(GLOT_SECRET_COOKIE, null, `.${window.location.host.split('.').splice(1, 2).join('.')}`)
      localStorage.removeItem('accessToken')
      this.$store.dispatch('updateLastUser', {type: '', name: '', photo: ''})
    },
    loginJWT:_throttle(function (vm) {
      vm.errMessage = ''
      // Loading
      vm.$vs.loading({
        background: 'rgba(0, 0, 0, 0.6)'
      })

      const payload = {
        userDetails: {
          email: vm.lastUser.name,
          password: vm.password
        }
      }

      vm.$store.dispatch('auth/loginJWT', payload)
        .then((res) => { 
          vm.$vs.loading.close()
          vm.$vs.notify({
            title: 'Login Success',
            text: 'Login Success',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })
          if ((vm.$route.query.continue || vm.$route.query.redirect_uri) && res.data.jwt) {

            let token = res.data.jwt
            const editorExtensionId = this.$route.query.extId
            if (token && editorExtensionId) {
              this.$store.dispatch('auth/loginExt', {token, extId: editorExtensionId})
            }
            let redirectlink = `${vm.$route.query.continue || vm.$route.query.redirect_uri}?token=${res.data.jwt}`
            Object.keys(vm.$route.query).map(key => {
              if (key !== 'continue') {
                redirectlink += `&${key}=${vm.$route.query[key]}`
              }
            })
            window.location.href = redirectlink
          }
        })
        .catch(error => {
          vm.$vs.loading.close()
          vm.$vs.loading.close()
          vm.errMessage = getErrorMessage(error.messages)
          vm.$vs.notify({
            title: 'Error',
            text: getErrorMessage(error.messages),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
            fixed: true
          })
        })
    }),
    validForm (scope) {
      const vm = this
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          // eslint-disable-next-line
           vm.loginJWT(this)
        }
      })
    },
    callOnSuccess () {
    },
    callOnFailure () {
    }
  },
  beforeDestroy () {
    const self = this
    document.removeEventListener('AppleIDSignInOnSuccess', self.callOnSuccess)
    document.removeEventListener('AppleIDSignInOnFailure', self.callOnFailure)
  },
  mounted () {
    if (!window.AppleID) {
      this.err('"https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js" needs to be included as a <script>')
      return
    }
    const clientId = this.clientId
    const scope = this.scope
    const redirectURI = this.redirectURI
    const state = this.state
    const nonce = this.nonce
    const usePopup = this.usePopup === 'true'

    if (!clientId) {
      this.err('options.clientId must be specified.')
      return
    }

    if (!redirectURI) {
      this.err('options.redirectURI must be specified.')
      return
    }

    if (!state) {
      this.err('options.state must be specified.')
      return
    }

    window.AppleID.auth.init({
      clientId,
      scope,
      redirectURI,
      state,
      usePopup,
      nonce
    })
    const self = this
    document.addEventListener('AppleIDSignInOnSuccess', self.callOnSuccess)
    document.addEventListener('AppleIDSignInOnFailure', self.callOnFailure)
  }
}
</script>

<style lang="scss">
.login-tabs-container {
  min-height: 505px;

  .con-tab {
    padding-bottom: 14px;
  }

  .con-slot-tabs {
    margin-top: 1rem;
  }
}
</style>
